import { type FunctionComponent, memo } from "react";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { IProps } from "./remove-field-button.types";
import "./remove-field-button.scss";

/**
 * Component for a button to remove a field/filter.
 * @param {function} props.onClick - Function to handle the click event for removing the field.
 * @returns {JSX.Element} RemoveFieldButton component.
 */
const RemoveFieldButton: FunctionComponent<IProps> = ({ onClick }) => {
    return (
        <div className="remove-field-button">
            <button onClick={onClick} type="button">
                <FontAwesomeIcon title="remove-filter" name="remove-filter" icon={faTimes} />
            </button>
        </div>
    );
};

export default memo(RemoveFieldButton);
